<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <wiz-hgroup width="100%" height="30px" verticalAlign="center" padding="3px" gap="2">
    <wiz-label width="100%" class="smallTitleLabel" [wizLabel]="'$.pivot.delete.lines.title.$'"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>
  
  <wiz-hgroup *ngIf="showScenLabel" class="widget-scen-Label" verticalAlign="center" style="padding-left: 5px;">
    <span
    #blockBack
    [style.backgroundColor]="scenColor"
    width="10px"
    height="10px"
    class="scen-round-mark" 
    ></span>
    <wiz-label
    [wizLabel]="scenLabel"
    [wizTextBehavior]="'truncate'"
    [wizTooltip]="scenLabel"
    ></wiz-label><!--[visible]="showScenLabel"-->
  </wiz-hgroup>

  <wiz-hgroup padding="5px" width="100%" height="100%">
    <wiz-ag-grid #agGrid width="100%" height="100%" [wizDatasource]="mainDS" class="ag-theme-alpine"></wiz-ag-grid>
  </wiz-hgroup>

  <wiz-hgroup width="100%" padding="5px" verticalAlign="center" horizontalAlign="end">
    <wiz-button
      [wizLabel]="'$.pivot.delete.lines.$'"
      [wizIcon]="'delete'"
      [iconPlacement]="'left'"
      (wizClick)="doDelete()"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
